<app-multiprofile-regular *ngIf='m_state===1' 
    (m_state_changed)="changeStateHandler($event)" 
    [editMode]="editMode" (editMode_changed)="changeEditModeHandler($event)"
    (selectedProfile_changed)="changeSelectedProfile($event)"></app-multiprofile-regular>
<app-multiprofile-newprofile *ngIf='m_state===2' (m_state_changed)="changeStateHandler($event)"></app-multiprofile-newprofile>
<app-multiprofile-edit *ngIf='m_state===3' [selectedProfile]="selectedProfile" (m_state_changed)="changeStateHandler($event)"></app-multiprofile-edit>
<app-multiprofile-delete *ngIf='m_state===4' [selectedProfile]="selectedProfile" (m_state_changed)="changeStateHandler($event)"></app-multiprofile-delete>
